import { memo } from 'react';
import { PersonIdDocument } from 'shared/components/(wallets)/kyc/PersonIdDocument';

export const DocumentStep = memo(() => {
    return <PersonIdDocument />;
});

DocumentStep.displayName = 'DocumentStep';
